<template>
<div>
    <h1 class="text-h5 my-5">
        Settings
    </h1>

    <v-tabs height="40" show-arrows slider-size="2">
        <v-tab v-for="t in tabs" :key="t.id" :to="{params: {tab: t.id}}" exact-path>
            {{t.name}}
        </v-tab>
    </v-tabs>

    <Projects v-if="!tab" :workspaceId="workspaceId" />
    <Team v-if="tab === 'team'" :workspaceId="workspaceId" />
    <Integrations v-if="tab === 'integrations'" :workspaceId="workspaceId" />
    <Categories v-if="tab === 'categories'" :workspaceId="workspaceId" />
    <Inspections v-if="tab === 'inspections'" :workspaceId="workspaceId" />
    <Billing v-if="tab === 'billing'" :workspaceId="workspaceId" />
</div>
</template>

<script>
import Projects from "@/pages/console/Projects.vue";
import Team from "@/pages/console/Team.vue";
import Integrations from "@/pages/console/Integrations.vue";
import Categories from "@/pages/console/Categories.vue";
import Inspections from "@/pages/console/Inspections.vue";
import Billing from "@/pages/console/Billing.vue";

export default {
    components: {Projects, Team, Integrations, Categories, Inspections, Billing},

    props: {
        workspaceId: String,
        tab: String,
    },

    computed: {
        tabs() {
            return [
                {id: undefined, name: 'General'},
                {id: 'team', name: 'Team'},
                {id: 'integrations', name: 'Integrations'},
                {id: 'categories', name: 'Categories'},
                {id: 'inspections', name: 'Inspections'},
                {id: 'billing', name: 'Billing'},
            ];
        },
    }
}
</script>


<style scoped>

</style>